import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc, collection, addDoc } from 'firebase/firestore';
import { Mail, MapPin, Send, MessageCircle } from 'lucide-react';
import './Contact.css';

const Contact: React.FC = () => {
  const [contactData, setContactData] = useState({
    email: 'info.giepei@gmail.com',
    location: 'Angola / Brasil'
  });
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    assunto: '',
    mensagem: ''
  });

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const settingsSnap = await getDoc(doc(db, 'settings', 'main'));
        if (settingsSnap.exists()) {
          const data = settingsSnap.data();
          setContactData({
            email: data.contactEmail || 'info.giepei@gmail.com',
            location: data.contactLocation || 'Angola / Brasil'
          });
        }
      } catch (err) {
        console.error("Erro ao carregar informações de contacto:", err);
      }
    };
    fetchContactInfo();
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 1. Guardar no Firestore (Cópia de Segurança)
      await addDoc(collection(db, 'mensagens_contacto'), {
        ...formData,
        data: new Date(),
        lida: false
      });

      // 2. Enviar por E-mail através do Gateway PHP
      try {
        await fetch('https://isppu.ao/mail/gateway.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            to: 'info.giepei@gmail.com',
            subject: `Novo contacto GIEPEI: ${formData.assunto}`,
            email: formData.email,
            nome: formData.nome,
            message: `
              Nome: ${formData.nome}
              E-mail: ${formData.email}
              Assunto: ${formData.assunto}
              Mensagem:
              ${formData.mensagem}
            `
          })
        });
      } catch (mailErr) {
        console.warn("Aviso: Falha ao enviar notificação por e-mail, mas a mensagem foi gravada na base de dados.");
      }

      alert('Sua mensagem foi enviada com sucesso! Entraremos em contacto em breve.');
      setFormData({
        nome: '',
        email: '',
        assunto: '',
        mensagem: ''
      });
    } catch (err) {
      alert('Erro ao enviar mensagem. Por favor, tente novamente mais tarde.');
    }
    setLoading(false);
  };

  return (
    <div className="contact-page">
      <div className="container" style={{ paddingTop: '4rem' }}>
        <h1 className="page-title">Contacto</h1>
        <div className="underline" style={{ margin: '0 auto 3rem' }}></div>
      </div>

      <div className="container contact-container">
        <div className="contact-grid">
          {/* Informações de Contacto */}
          <div className="contact-info-section">
            <h3>Entre em Contacto</h3>
            <p className="contact-intro">
              Tem alguma dúvida ou deseja colaborar connosco? Estamos à sua disposição.
            </p>

            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon">
                  <Mail size={24} />
                </div>
                <div className="info-content">
                  <h4>E-mail</h4>
                  <a href={`mailto:${contactData.email}`}>{contactData.email}</a>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">
                  <MapPin size={24} />
                </div>
                <div className="info-content">
                  <h4>Localização</h4>
                  <p>{contactData.location}</p>
                </div>
              </div>

              <div className="info-card">
                <div className="info-icon">
                  <MessageCircle size={24} />
                </div>
                <div className="info-content">
                  <h4>Canais Oficiais</h4>
                  <div className="social-links">
                    <a href="https://whatsapp.com/channel/0029VbCkEG6HFxOspdrwQb1g" target="_blank" rel="noopener noreferrer">WhatsApp</a>
                    <span> | </span>
                    <a href="https://www.youtube.com/@GIEPEI" target="_blank" rel="noopener noreferrer">YouTube</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Formulário Real */}
          <div className="contact-form-section">
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label>Nome Completo</label>
                <input 
                  type="text" 
                  value={formData.nome}
                  onChange={e => setFormData({...formData, nome: e.target.value})}
                  placeholder="Seu nome" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>E-mail</label>
                <input 
                  type="email" 
                  value={formData.email}
                  onChange={e => setFormData({...formData, email: e.target.value})}
                  placeholder="seu@email.com" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Assunto</label>
                <input 
                  type="text" 
                  value={formData.assunto}
                  onChange={e => setFormData({...formData, assunto: e.target.value})}
                  placeholder="Assunto da mensagem" 
                  required 
                />
              </div>
              <div className="form-group">
                <label>Mensagem</label>
                <textarea 
                  rows={5} 
                  value={formData.mensagem}
                  onChange={e => setFormData({...formData, mensagem: e.target.value})}
                  placeholder="Como podemos ajudar?" 
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                <Send size={18} style={{ marginRight: '10px' }} />
                {loading ? 'Enviando...' : 'Enviar Mensagem'}
              </button>
            </form>
          </div>
        </div>

        {/* Assinatura apenas para Mobile */}
        <div className="mobile-signature mobile-only">
          <hr className="styled-hr" />
          <p>Desenvolvido por BRIDNOLOGY</p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
